import { Box, Card, Image, Button, Link } from "@chakra-ui/react";
import { RiArrowRightLine } from "react-icons/ri";

const ServiceCard = ({ src, title, desc, ...props }) => {
  return (
    <Card.Root
      boxShadow="rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px;"
      color="#a20c0b"
      maxW="xs"
      bgColor="transparent"
      border="1px solid #a20c0b"
      borderRadius="2xl"
      p={{ base: "0", md: "0", lg: "3" }}
      _hover={{
        boxShadow:
          "rgba(0, 0, 0, 0.4) 0px 2px 4px, rgba(0, 0, 0, 0.3) 0px 7px 13px -3px, rgba(0, 0, 0, 0.2) 0px -3px 0px inset;",
        bgColor: "#a20c0b10",
        transition: "all ease 0.2s",
        backdropFilter: "blur(10px)",
      }}
      {...props}
    >
      <Card.Body gap="2">
        <Box bg="#a20c0b" borderRadius="full" w="fit-content" p="3">
          <Image
            src={src}
            alt="service icon"
            boxSize={{ base: "6", md: "6", lg: "10" }}
          />
        </Box>
        <Card.Title>{title}</Card.Title>
        <Card.Description>{desc}</Card.Description>
      </Card.Body>
    </Card.Root>
  );
};

const ImageServiceCard = ({ src, title, desc, ...props }) => {
  const message = `Hello, I'm interested in the ${title} service. Can you provide more details?`;
  const whatsappUrl = `https://wa.me/919152832898?text=${encodeURIComponent(
    message
  )}`;

  return (
    <Card.Root
      boxShadow="rgba(14, 30, 37, 0.12) 0px 2px 4px 0px, rgba(14, 30, 37, 0.32) 0px 2px 16px 0px;"
      color="#a20c0b"
      bgColor="transparent"
      maxW="sm"
      border="1px solid #a20c0b"
      borderRadius="2xl"
      overflow="hidden"
      _hover={{
        boxShadow:
          "rgba(0, 0, 0, 0.4) 0px 2px 4px, rgba(0, 0, 0, 0.3) 0px 7px 13px -3px, rgba(0, 0, 0, 0.2) 0px -3px 0px inset;",
        bgColor: "#a20c0b10",
        transition: "all 300ms",
        backdropFilter: "blur(10px)",
      }}
      alignItems={"center"}
      {...props}
    >
      <Image
        src={src}
        alt={title}
        w="full"
        h={{ base: "200px", md: "150px", lg: "200px" }}
        objectFit="cover"
      />
      <Card.Body gap="2">
        <Card.Title fontSize={{ base: "lg", md: "md", lg: "lg" }} lineClamp={1}>
          {title}
        </Card.Title>
        <Card.Description color="gray">{desc}</Card.Description>
      </Card.Body>
      <Card.Footer>
        <Link href={whatsappUrl} isExternal>
          <Button variant="plain" _hover={{ color: "#a20c0b" }} color="gray">
            Get Started <RiArrowRightLine />
          </Button>
        </Link>
      </Card.Footer>
    </Card.Root>
  );
};

export { ServiceCard, ImageServiceCard };
